import { render } from "./ShoppingCartComponent.vue?vue&type=template&id=75801c70"
import script from "./ShoppingCartComponent.vue?vue&type=script&lang=js"
export * from "./ShoppingCartComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__